// src/utils/iconResolver.js
function pickDensity(dpr) {
  if (dpr >= 2.75) return "3x";
  if (dpr >= 1.75) return "2x";
  return "1x";
}

function toSrcSetString(srcset) {
  if (!srcset) return;
  const parts = [];
  if (srcset["1x"]) parts.push(`${srcset["1x"]} 1x`);
  if (srcset["2x"]) parts.push(`${srcset["2x"]} 2x`);
  if (srcset["3x"]) parts.push(`${srcset["3x"]} 3x`);
  return parts.length ? parts.join(", ") : undefined;
}

export function resolveIcon(styles, opts) {
  if (!opts || !opts.slot) return null;

  const dpr = opts.dpr || (typeof window !== "undefined" ? window.devicePixelRatio || 1 : 1);
  const slot = styles?.assets?.icons?.[opts.slot];

  if (slot && slot.url) {
    const density = pickDensity(dpr);
    const srcFromSet = slot.srcset && slot.srcset[density];
    const src = srcFromSet || slot.url;
    if (src) {
      return {
        src,
        srcSet: toSrcSetString(slot.srcset),
        alt: slot.alt || "Brand",
        width: slot.width,
        height: slot.height,
      };
    }
  }

  if (opts.fallback && (opts.fallback.url || opts.fallback.srcset)) {
    return {
      src: opts.fallback.url || (opts.fallback.srcset && opts.fallback.srcset["1x"]),
      srcSet: toSrcSetString(opts.fallback.srcset),
      alt: opts.fallback.alt || "Brand",
      width: opts.fallback.width,
      height: opts.fallback.height,
    };
  }

  return null;
}